module.exports = __webpack_public_path__ + "img/mens_logo.5a2af1a7.png";